export default __webpack_public_path__ + "static/media/selfie.b3f5e75c.jpg";